import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=44c0d69d&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=44c0d69d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c0d69d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c0d69d')) {
      api.createRecord('44c0d69d', component.options)
    } else {
      api.reload('44c0d69d', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=44c0d69d&scoped=true&", function () {
      api.rerender('44c0d69d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bhCef0gGyCIB/JS/comp/PopupBox.vue"
export default component.exports